"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var guard_exports = {};
__export(guard_exports, {
  isAnySchema: () => isAnySchema,
  isArraySchema: () => isArraySchema,
  isBooleanSchema: () => isBooleanSchema,
  isDictSchemaOf: () => isDictSchemaOf,
  isGeometrySchema: () => isGeometrySchema,
  isIntegerSchema: () => isIntegerSchema,
  isLabeledSchema: () => isLabeledSchema,
  isMaybeNullableSchema: () => isMaybeNullableSchema,
  isNullableSchema: () => isNullableSchema,
  isNumberSchema: () => isNumberSchema,
  isNumericSchema: () => isNumericSchema,
  isProductSchema: () => isProductSchema,
  isSchema: () => isSchema,
  isStringSchema: () => isStringSchema,
  isSumSchema: () => isSumSchema,
  isTimestampSchema: () => isTimestampSchema,
  isTupleSchema: () => isTupleSchema,
  isTupleSchemaOf: () => isTupleSchemaOf,
  isUnknownSchema: () => isUnknownSchema,
  isUuidSchema: () => isUuidSchema,
  productHasField: () => productHasField,
  sumHasProduct: () => sumHasProduct
});
module.exports = __toCommonJS(guard_exports);
var import_geometry = require("@cartographerio/geometry");
var import_guard = require("@cartographerio/guard");
var import_lodash = require("lodash");
function isAnySchema(_schema) {
  return true;
}
function isBooleanSchema(schema) {
  return schema.type === "Boolean";
}
function isIntegerSchema(schema) {
  return schema.type === "Integer";
}
function isNumberSchema(schema) {
  return schema.type === "Number";
}
function isNumericSchema(schema) {
  return isIntegerSchema(schema) || isNumberSchema(schema);
}
function isStringSchema(schema) {
  return schema.type === "String";
}
function isUuidSchema(schema) {
  return schema.type === "Uuid";
}
function isTimestampSchema(schema) {
  return schema.type === "Timestamp";
}
function isGeometrySchema(geometryType) {
  return (schema) => {
    return schema.type === "Geometry" && (geometryType == null || schema.geometryType === geometryType);
  };
}
function isUnknownSchema(schema) {
  return schema.type === "Unknown";
}
function isNullableSchema(pred) {
  return (schema) => schema.type === "Nullable" && pred(schema.param);
}
function isMaybeNullableSchema(pred) {
  return (schema) => pred(schema) || isNullableSchema(pred)(schema);
}
function isArraySchema(pred) {
  return (schema) => schema.type === "Array" && pred(schema.param);
}
function isTupleSchema(schema) {
  return schema.type === "Tuple";
}
function isTupleSchemaOf(...preds) {
  return (schema) => schema.type === "Tuple" && preds.length === schema.items.length && preds.every((pred, index) => pred(schema.items[index]));
}
function isDictSchemaOf(isKey = import_guard.isString, isValue = isAnySchema) {
  return (schema) => schema.type === "Dict" && isKey(schema.key) && isValue(schema.value);
}
function isProductSchema(schema) {
  return schema.type === "Product";
}
function productHasField(schema, name, guard) {
  return (0, import_guard.hasKeyOfAnyType)(schema.fields, name) && guard(schema.fields[name]);
}
function isSumSchema(schema) {
  return schema.type === "Sum";
}
function sumHasProduct(schema, name, guard) {
  return (0, import_guard.hasKeyOfAnyType)(schema.products, name) && guard(schema.products[name]);
}
function isLabeledSchema(label, guard) {
  return (schema) => isSumSchema(schema) && sumHasProduct(schema, label, guard);
}
function isSchema(schema) {
  if ((0, import_lodash.isObject)(schema) && (0, import_guard.hasKeyOfAnyType)(schema, "type")) {
    switch (schema.type) {
      case "Boolean":
        return true;
      case "Integer":
        return true;
      case "Number":
        return true;
      case "String":
        return true;
      case "Uuid":
        return true;
      case "Timestamp":
        return true;
      case "Point":
        return true;
      case "Geometry": {
        return "geometryType" in schema ? (0, import_guard.hasKey)(schema, "geometryType", (0, import_guard.isNullable)(import_geometry.isGeometryAtomType)) : true;
      }
      case "Enum":
        return (0, import_guard.hasKey)(schema, "values", (0, import_guard.isArrayOf)(import_guard.isString));
      case "Nullable":
        return (0, import_guard.hasKey)(schema, "param", isSchema);
      case "Array":
        return (0, import_guard.hasKey)(schema, "param", isSchema);
      case "Tuple":
        return (0, import_guard.hasKey)(schema, "items", (0, import_guard.isArrayOf)(isSchema));
      case "Dict":
        return (0, import_guard.hasKey)(schema, "key", isSchema) && (0, import_guard.hasKey)(schema, "value", isSchema);
      case "Product":
        return (0, import_guard.hasKey)(schema, "fields", (0, import_guard.isRecordOf)(import_guard.isString, isSchema));
      case "Sum":
        return (0, import_guard.hasKey)(schema, "products", (0, import_guard.isRecordOf)(import_guard.isString, isProductSchema));
      default:
        return false;
    }
  } else {
    return false;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isAnySchema,
  isArraySchema,
  isBooleanSchema,
  isDictSchemaOf,
  isGeometrySchema,
  isIntegerSchema,
  isLabeledSchema,
  isMaybeNullableSchema,
  isNullableSchema,
  isNumberSchema,
  isNumericSchema,
  isProductSchema,
  isSchema,
  isStringSchema,
  isSumSchema,
  isTimestampSchema,
  isTupleSchema,
  isTupleSchemaOf,
  isUnknownSchema,
  isUuidSchema,
  productHasField,
  sumHasProduct
});
//# sourceMappingURL=guard.js.map
